import React from "react";
import { SvgIcon } from "../Components/SvgIcons";

function PlayerSecurity() {
	return (
		<>
			<div className="overviewTableWrapper">
				<div className="overviewTableChild">
					<div className="d-flex flex-wrap">
						<div className="col-12">
							<div className="heading">
								<div className="content">
									<h4>
										Player Security{" "}
										<button className="clearButton">
											<SvgIcon name="refresh" />
										</button>
									</h4>
								</div>
								<div className="buttonGroup">
									<button effect="ripple" className="panelButton gray">
										<span className="text">Back</span>
										<span className="icon">
											<SvgIcon name="back" />
										</span>
									</button>
									<button type="button" className="panelButton">
										<span className="text">Add</span>
										<span className="icon">
											<SvgIcon name="plus" />
										</span>
									</button>
								</div>
							</div>
						</div>
						<div className="col-12" style={{ overflow: "auto", padding: "10px 20px 0px" }}>
							<div className="tableHeader">
								<div className="showEntries">
									<label>Show</label>
									<select className="formItem">
										<option value={10}>10</option>
										<option value={20}>20</option>
										<option value={30}>30</option>
									</select>
									<label>entries</label>
								</div>
								<div className="searchBox position-relative">
									<label>Search:</label>
									<input type="search" name="Search" className="formItem" defaultValue="" />
								</div>
							</div>
							<div className="tableContainer">
								<table>
									<thead>
										<tr>
											<th>#</th>
											<th>Username</th>
											<th>Last Login IP</th>
											<th>Status</th>
											<th>Approved By</th>
											<th>Date</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td>1</td>
											<td>####</td>
											<td>####</td>
											<td>
												<span className="tableLabel success">Approved</span>
											</td>
											<td>####</td>
											<td>####</td>
											<td>
												<button className="tableButton edit">
													<SvgIcon name="check" />
												</button>
											</td>
										</tr>
									</tbody>
								</table>
							</div>
							<div className="tableHeader mb-3">Pagination</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default PlayerSecurity;
